import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Service from "../../API/Service";
import MyInput from "../../components/UI/MyInput/MyInput";
import MyButton from "../../components/UI/MyButtons/MyButton";
import parent from "../../styles/StudEditPage.module.css";
import block from "../../Assets/icons/lock_red.svg";
import unblock from "../../Assets/icons/unblock.svg";

const AdminEditPage = () => {
    const navigate = useNavigate();
    const {id} = useParams();

    const [updatedData, setUpdatedData] = useState({
        name: "",
        surname: "",
        birthDate: "",
        login: "",
        phone: "",
        isBlocked: false
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getById(id, "admins");
                const data = response?.data || {};

                setUpdatedData({
                    name: data.name || "",
                    surname: data.surname || "",
                    birthDate: data.birthDate || "",
                    login: data.login || "",
                    phone: data.phone || "",
                    isBlocked: data.isBlocked || false
                });

            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    const handleChange = (field, value) => {
        setUpdatedData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = async () => {
        try {
            const updatedPayload = {
                name: updatedData.name,
                surname: updatedData.surname,
                birthDate: updatedData.birthDate,
                login: updatedData.login,
                phone: updatedData.phone,
            };

            const response = await Service.updateData(id, updatedPayload, "admins");

            if (response.status === 200) {
                alert("Админ успешно обновлен!");
                navigate(-1);
            } else {
                alert("Ошибка при обновлении!");
            }
        } catch (error) {
            console.error("Ошибка:", error);
            alert("Ошибка при обновлении!");
        }
    };

    const blockAdmin = async () => {
        try{
            const response = await Service.blockUser("admins", id)

            if (response.status === 200) {
                setUpdatedData(prev => ({...prev, isBlocked: true}));
                console.log("Admin with ID:" + id + " is blocked");
            } else {
                alert("Ошибка при блокировке!");
            }
        } catch (error){
            console.error("Ошибка:", error);
        }
    }

    const unblockAdmin = async () => {
        try{
            const response = await Service.unblockUser("admins", id)

            if (response.status === 200) {
                console.log("Admin with ID:" + id + " is unblocked");
                setUpdatedData(prev => ({...prev, isBlocked: false}));
            } else {
                console.log("Ошибка при разблокировке!");
            }
        } catch (error){
            console.error("Ошибка:", error);
        }
    }

    return (
        <div className={parent.mainBlock}>
            <div className={parent.header}>
                <p>Admin</p>
                {!updatedData.isBlocked?(
                    <div className={parent.blockBtn} onClick={() => blockAdmin()}>
                        Block admin
                        <img src={block} alt={'block'}/>
                    </div>
                ):(
                    <div className={parent.unblockBtn} onClick={() => unblockAdmin()}>
                        Unblock admin
                        <img src={unblock} alt={'unblock'}/>
                    </div>
                )}
            </div>
            <div className={parent.content}>
                <MyInput
                    onChange={(value) => handleChange("name", value)}
                    info={{ name: "Name", value: updatedData.name }}
                    isDisabled={false}
                />
                <MyInput
                    onChange={(value) => handleChange("surname", value)}
                    info={{ name: "Surname", value: updatedData.surname }}
                    isDisabled={false}
                />
                {/*<MyInput*/}
                {/*    onChange={(value) => handleChange("birthDate", value)}*/}
                {/*    info={{ name: "Date of Birth", value: updatedData.birthDate }}*/}
                {/*    isDisabled={false}*/}
                {/*/>*/}
                {/*<MyInput*/}
                {/*    onChange={(value) => handleChange("login", value)}*/}
                {/*    info={{ name: "Email", value: updatedData.login }}*/}
                {/*    isDisabled={false}*/}
                {/*/>*/}
                <MyInput
                    onChange={(value) => handleChange("phone", value)}
                    info={{ name: "Phone Number", value: updatedData.phone }}
                    isDisabled={false}
                />
                <div className={parent.buttons}>
                    <MyButton
                        content={"Back"}
                        isBlue={false}
                        onClick={() => navigate(-1)}
                    />
                    <MyButton
                        content={"Save changes"}
                        isBlue={true}
                        onClick={handleSave}
                    />
                </div>
            </div>
        </div>
    );
};

export default AdminEditPage;